import React from 'react';
import {
    Box, Flex, HStack, Text, Input, Select, Checkbox, Button, Tooltip, Collapse, useBreakpointValue,
} from '@chakra-ui/react';
import { FaFilter, FaBackspace, FaChevronDown, FaChevronUp, FaCamera } from 'react-icons/fa';

const Label = ({ children }) => (
    <Text color="#F68633" fontSize="10px" fontWeight="bold">{children}</Text>
);

const FiltroInput = ({ label, ...props }) => (
    <Box>
        {label && <Label>{label}</Label>}
        <Input size="sm" bg="white" width={{ base: '100%', md: '130px' }} {...props} />
    </Box>
);

const FiltroSelect = ({ label, options, width, ...props }) => (
    <Box>
        {label && <Label>{label}</Label>}
        <Select size="sm" bg="white" width={width || { base: '100%', md: '130px' }} {...props}>
            {options.map(([val, text]) => (<option key={val} value={val}>{text}</option>))}
        </Select>
    </Box>
);

const FiltroData = ({ label, ...props }) => (
    <Box>
        {label && <Label>{label}</Label>}
        <Input type="date" size="sm" bg="white" width={{ base: '100%', md: '130px' }} {...props} />
    </Box>
);

const STATUS_COMPLETO = [
    ['', 'Todos'], ['opened', 'Aberta'], ['shipped', 'Enviada'],
    ['delivered', 'Entregue'], ['closed', 'Fechada'], ['not_delivered', 'Não Entregue'],
    ['cancelled', 'Cancelada'], ['failed', 'Falhada'], ['expired', 'Expirada'],
    ['label_generated', 'Etiqueta Gerada'],
];

const STATUS_RECLAMACAO_OPTIONS = [
    ['', 'Todos'], ['opened', 'Aberta'], ['closed', 'Encerrada'],
];

const STATUS_LIST = [
    ['', 'Todos'], ['opened', 'Aberta'], ['shipped', 'Enviada'],
    ['closed', 'Fechada'], ['delivered', 'Entregue'],
];

const OWNER_OPTIONS = [
    ['', 'Todos'],
    ['buyer', 'Devolvido ao cliente'],
    ['ml', 'Retido pelo ML'],
    ['seller', 'Valor recuperado'],
    ['unknown', 'Indefinido'],
];

const CONTA_OPTIONS = [['', 'Todos'], ['1', 'Conta 1'], ['2', 'Conta 2'], ['3', 'Conta 3']];

const ORIGEM_OPTIONS = [
    ['', 'Todas'],
    ['taga', 'TAGA'],
    ['ecommerce', 'ECOMMERCE'],
    ['ml_1', 'ML 1'],
    ['ml_2', 'ML 2'],
    ['ml_3', 'ML 3'],
];

const ORDEM_OPTIONS = [
    ['padrao', 'Padrão (urgência)'],
    ['criada_recente', 'Criada mais recente'],
    ['criada_antiga', 'Criada mais antiga'],
    ['atualizada_recente', 'Atualizada mais recente'],
    ['sem_acao', 'Sem ação há mais tempo'],
    ['prazo_proximo', 'Prazo mais próximo'],
    ['valor_perdido_maior', 'Maior valor perdido'],
    ['valor_perdido_menor', 'Menor valor perdido'],
    ['valor_venda_maior', 'Maior valor da venda'],
    ['status', 'Por status'],
];

const FilterFrame = ({ isExpanded, onToggle, header, children }) => {
    const isMobile = useBreakpointValue({ base: true, md: false });
    return (
        <Box
            w="100%" mx="auto" mt={2}
            border="1px solid #FF9F59" borderRadius="lg" boxShadow="md"
            position="static" zIndex={1} bg="gray.50"
        >
            <HStack justify="space-between" px={{ base: 2, md: 4 }} pt={2}>
                <Text fontSize="8px" textAlign="center" color="#F68633" fontWeight="bold" position="relative" top="-14px" bg="white" w="50px" px={1} borderRadius="lg" border="1px solid #FF9F59">
                    FILTROS
                </Text>
                <Button
                    display={{ base: 'flex', md: 'none' }}
                    size="sm" variant="ghost" colorScheme="orange"
                    onClick={onToggle}
                    leftIcon={isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                >
                    {isExpanded ? 'Ocultar' : 'Mostrar Filtros'}
                </Button>
            </HStack>
            {header}
            <Collapse in={isMobile ? isExpanded : true}>
                {children}
            </Collapse>
        </Box>
    );
};

export const DevolucoesFiltersList = ({
    idVenda, setIdVenda,
    filtroConta, setFiltroConta,
    status, setStatus,
    statusReceb, setStatusReceb,
    statusRev, setStatusRev,
    moneyOwner, setMoneyOwner,
    ateHoje, setAteHoje,
    dataInicial, setDataInicial,
    dataFinal, setDataFinal,
    onFiltrar, onLimpar,
    isExpanded, onToggleExpanded,
}) => (
    <FilterFrame isExpanded={isExpanded} onToggle={onToggleExpanded}>
        <Flex px={{ base: 2, md: 4 }} pb={4} flexDirection={{ base: 'column', md: 'row' }} wrap="wrap" gap={3} justify="center">
            <FiltroInput label="ID DA VENDA" value={idVenda} onChange={e => setIdVenda(e.target.value)} placeholder="ID da venda" />
            <FiltroSelect label="CONTA" value={filtroConta} onChange={e => setFiltroConta(e.target.value)} options={CONTA_OPTIONS} />
            <FiltroSelect label="STATUS DEVOLUÇÃO" value={status} onChange={e => setStatus(e.target.value)} options={STATUS_LIST} />
            <FiltroSelect label="STATUS RECEBIMENTO" value={statusReceb} onChange={e => setStatusReceb(e.target.value)} options={[['', 'Todos'], ['true', 'Recebida'], ['false', 'Não recebida']]} />
            <FiltroSelect label="STATUS REVISÃO" value={statusRev} onChange={e => setStatusRev(e.target.value)} options={[['', 'Todos'], ['true', 'Revisada'], ['false', 'Não revisada']]} />
            <FiltroSelect label="DINHEIRO" value={moneyOwner} onChange={e => setMoneyOwner(e.target.value)} options={OWNER_OPTIONS} />
            <Box alignSelf="flex-end">
                <Checkbox isChecked={ateHoje} onChange={e => setAteHoje(e.target.checked)}>Revisão até hoje</Checkbox>
            </Box>
            <FiltroData label="DATA INICIAL" value={dataInicial} onChange={e => setDataInicial(e.target.value)} max={dataFinal} />
            <FiltroData label="DATA FINAL" value={dataFinal} onChange={e => setDataFinal(e.target.value)} min={dataInicial} />
        </Flex>
        <Flex justify="center" align="center" pb={4}>
            <Tooltip label="Filtrar">
                <Button colorScheme="orange" size="sm" mr={2} onClick={onFiltrar} leftIcon={<FaFilter />}>Filtrar</Button>
            </Tooltip>
            <Tooltip label="Limpar Filtros">
                <Button colorScheme="gray" size="sm" onClick={onLimpar} leftIcon={<FaBackspace />}>Limpar</Button>
            </Tooltip>
        </Flex>
    </FilterFrame>
);

export const DevolucoesFiltersKanban = ({
    search, setSearch,
    origem, setOrigem,
    status, setStatus,
    statusReclamacao, setStatusReclamacao,
    moneyOwner, setMoneyOwner,
    dataInicial, setDataInicial,
    dataFinal, setDataFinal,
    ordem, setOrdem,
    onLimpar, onScan,
    isExpanded, onToggleExpanded,
}) => (
    <FilterFrame
        isExpanded={isExpanded}
        onToggle={onToggleExpanded}
        header={
            <Box px={{ base: 2, md: 4 }} pb={3} pt={0} display={{ base: 'block', md: 'none' }}>
                <Label>BUSCA</Label>
                <Flex direction="column" gap={2}>
                    <Input
                        size="sm" bg="white"
                        w="100%"
                        placeholder="ID, Produto, Cliente, SKU..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                    {onScan && (
                        <Button
                            size="sm"
                            colorScheme="orange"
                            w="100%"
                            onClick={onScan}
                            leftIcon={<FaCamera />}
                        >
                            Escanear
                        </Button>
                    )}
                </Flex>
            </Box>
        }
    >
        <Flex px={{ base: 2, md: 4 }} pb={4} pt={0} flexDirection={{ base: 'column', md: 'row' }} wrap="wrap" gap={3} justify="center">
            <Box display={{ base: 'none', md: 'block' }}>
                <Label>BUSCA</Label>
                <Input
                    size="sm" bg="white"
                    width={{ md: '200px' }}
                    placeholder="ID, Produto, Cliente, SKU..."
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
            </Box>
            <FiltroSelect label="ORIGEM" value={origem} onChange={e => setOrigem(e.target.value)} options={ORIGEM_OPTIONS} />
            <FiltroSelect label="STATUS RECLAMAÇÃO" value={statusReclamacao || ''} onChange={e => setStatusReclamacao && setStatusReclamacao(e.target.value)} options={STATUS_RECLAMACAO_OPTIONS} />
            <FiltroSelect label="STATUS DEVOLUÇÃO" value={status} onChange={e => setStatus(e.target.value)} options={STATUS_COMPLETO} />
            <FiltroSelect label="DINHEIRO" value={moneyOwner} onChange={e => setMoneyOwner(e.target.value)} options={OWNER_OPTIONS} />
            <FiltroSelect label="ORDENAR POR" value={ordem || 'padrao'} onChange={e => setOrdem && setOrdem(e.target.value)} options={ORDEM_OPTIONS} width={{ base: '100%', md: '180px' }} />
            <FiltroData label="DATA INICIAL" value={dataInicial} onChange={e => setDataInicial(e.target.value)} max={dataFinal} />
            <FiltroData label="DATA FINAL" value={dataFinal} onChange={e => setDataFinal(e.target.value)} min={dataInicial} />
            <Flex alignSelf={{ base: 'auto', md: 'flex-end' }}>
                <Tooltip label="Limpar Filtros">
                    <Button colorScheme="gray" size="sm" onClick={onLimpar} leftIcon={<FaBackspace />}>Limpar</Button>
                </Tooltip>
            </Flex>
        </Flex>
    </FilterFrame>
);
